import { handleOptionChange } from './utils';
import { Search } from '@cp/src/utils/search';
import { SearchIcon } from '@navi/web-ui/lib/icons';
import { BorderedInput, Typography } from '@navi/web-ui/lib/primitives';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { IOption, IRightPanel } from './types';
import SectionedOptions from './SectionedOptions';
import NormalOptions from './NormalOptions';

const RightPanel = (props: IRightPanel) => {
  const { filterSchema, selectedFilter, selectedOptions, setSelectedOptions, tableName } = props;

  const { options, key, isSearchEnabled } = filterSchema?.[selectedFilter] || {};
  const [filteredOptionsData, setFilteredOptions] = useState(options);

  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>, option: IOption) => {
    addClickstreamEvent(
      {
        name: `LH_${tableName}_FILTER_OPTION_SELECTED`,
        description: `LH_${tableName}_FILTER_OPTION_SELECTED`
      },
      {
        selectedOptions
      }
    );
    handleOptionChange(e, option, key, selectedOptions, filterSchema, setSelectedOptions);
  };

  const handleSearchQuery = (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    let res = [];
    if (query !== '') {
      res = Search(query, options, {
        all: true,
        keys: ['label']
      })?.map((item: Record<string, never>) => {
        return item.obj;
      });
    } else {
      res = options;
    }

    setFilteredOptions(res);
  };

  if (!options?.length)
    return (
      <Typography
        variant="h4"
        color="var(--grayscale-2)"
        className="flex items-center justify-center h-[calc(100%-46px)]"
      >
        No filters available
      </Typography>
    );

  return (
    <div>
      {isSearchEnabled && (
        <div className={styles.searchInput}>
          <BorderedInput
            ref={inputRef}
            onChange={handleSearchQuery}
            placeholder="Search"
            LeftInputAdornment={<SearchIcon />}
            containerClassName={styles.inputContainer}
          />
        </div>
      )}
      {filteredOptionsData?.length && filteredOptionsData[0]?.filterSectionLabel ? (
        <SectionedOptions
          filteredOptionsData={filteredOptionsData}
          filterSchema={filterSchema}
          selectedOptions={selectedOptions}
          selectedFilter={selectedFilter}
          handleCheckboxChange={handleCheckboxChange}
          setSelectedOptions={setSelectedOptions}
          isSearchEnabled={isSearchEnabled}
        />
      ) : (
        <NormalOptions
          filteredOptionsData={filteredOptionsData}
          filterSchema={filterSchema}
          selectedOptions={selectedOptions}
          selectedFilter={selectedFilter}
          handleCheckboxChange={handleCheckboxChange}
          setSelectedOptions={setSelectedOptions}
        />
      )}
    </div>
  );
};

export default RightPanel;
